import { providerOptions } from "@/shared/config/constants";

export const fmt = new Intl.NumberFormat("zh-CN");
export const compact = new Intl.NumberFormat("zh-CN", { notation: "compact", maximumFractionDigits: 1 });
export const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });

const sgDateTime = new Intl.DateTimeFormat("zh-CN", {
  timeZone: "Asia/Singapore",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

export function providerLabel(provider) {
  return providerOptions.find((item) => item.value === provider)?.label ?? provider;
}

export function cacheTokens(usage) {
  return (usage?.cacheReadTokens ?? 0) + (usage?.cacheCreationTokens ?? 0);
}

export function tokenKindLabel(kind) {
  return kind === "native_mac" ? "Mac App" : "Legacy CLI";
}

export function formatBytes(value) {
  if (!value) return "大小待发布";
  if (value < 1024 * 1024) return `${Math.round(value / 1024)} KB`;
  return `${(value / 1024 / 1024).toFixed(1)} MB`;
}

export function parseApiDate(value) {
  return new Date(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value) ? `${value.replace(" ", "T")}Z` : value);
}

export function formatUtc8DateTime(value) {
  return `${sgDateTime.format(parseApiDate(value))} UTC+8`;
}

export function usageDetailLine(usage) {
  if (usage.totalTokens === 0) return "待开始";
  if (usage.provider === "all" && usage.providerBreakdown?.length) {
    return usage.providerBreakdown.map((item) => `${providerLabel(item.provider)} ${compact.format(item.totalTokens)}`).join(" / ");
  }
  return usage.modelsUsed?.join(", ") || providerLabel(usage.provider);
}

export function padRank(rank) {
  if (rank == null) return "—";
  return String(rank).padStart(2, "0");
}

export function utc8(offset = 0) {
  const d = new Date(Date.now() + 8 * 60 * 60 * 1000);
  d.setUTCDate(d.getUTCDate() + offset);
  return d.toISOString().slice(0, 10);
}
